import { LosseKruumels } from '@ubo/losse-sjedel'

export default function Breadcrumbs() {
  return (
    <LosseKruumels
      type="fragment"
      className="children-ol:flex lossekruumel children-li:flex children-ol:items-start lg:children-ol:items-center text-sm text-site-accent hover:children-a:underline children-a:first-letter:uppercase children-a:inline-block"
      seperator={
        <span className="mx-2 sm:mx-3 flex items-start lg:items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </span>
      }
    />
  )
}
